<template>
  <div class="top5">
    <HeaderClassification
      v-if="top5 && top5.length > 0"
      @toggleItem="toggleItem"
    />
    <p v-if="$tvaMq === 'tablet'" class="top5__symbol">%</p>
    <ListItemClassification
      v-for="(item, index) in top5"
      :key="index"
      :item="item"
      @toggleItem="toggleItem"
    />
    <div v-if="top5 && top5.length == 0">No data</div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import HeaderClassification from "./HeaderClassification.vue";
import ListItemClassification from "./ListItemClassification.vue";

export default {
  name: "Top5",
  computed: {
    ...mapGetters({
      top5: "data/getTop5",
      selectedCountryId: "ui/selectedCountryId",
    }),
  },
  methods: {
    changeItem() {
      this.toggleItem(null, false);
    },
    toggleItem(item, active) {
      if (
        !!item &&
        (item.COUNTRY.toLowerCase() === "others" ||
          item.COUNTRY === "Rest of the World")
      ) {
        return;
      }
      this.hoverId = active ? item.GEO.id : null;
      this.setSelectedCountryId(null).then(() =>
        this.setSelectedCountryId(this.hoverId)
      );
    },
    ...mapActions({
      setSelectedCountryId: "ui/setSelectedCountryId",
    }),
  },
  components: { HeaderClassification, ListItemClassification },
};
</script>

<style lang="scss" scoped>
.top5 {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: $ui-white;
}

.tablet {
  .top5 {
    &__symbol {
      background-color: rgba(255, 255, 255, 0.05);
      border-bottom: $white-border;
      display: flex;
      align-items: center;
      padding-left: 1.95vw;
      min-height: 3.62vh;
    }
  }
}
</style>
